/**
 * Get the origin string from location data
 * @param {*} locationData
 * @returns {string}
 */
export const getOriginString = locationData => {
    const origin = locationData?.origin || {};
    const originStr = [origin.lat, origin.lng].filter(s => !!s).join(',');

    return originStr;
};
